export const exitIcon = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8519 16L24.9319 8.92C25.2244 8.6275 25.2244 8.155 24.9319 7.8625C24.6394 7.57 24.1669 7.57 23.8744 7.8625L16.7944 14.9425L9.71437 7.855C9.42187 7.5625 8.94937 7.5625 8.65687 7.855C8.36438 8.1475 8.36438 8.62 8.65687 8.9125L15.7369 15.9925L8.65687 23.0725C8.36438 23.365 8.36438 23.8375 8.65687 24.13C8.80687 24.28 8.99438 24.3475 9.18938 24.3475C9.38438 24.3475 9.57188 24.2725 9.72188 24.13L16.8019 17.05L23.8819 24.13C24.0319 24.28 24.2194 24.3475 24.4144 24.3475C24.6094 24.3475 24.7969 24.2725 24.9469 24.13C25.2394 23.8375 25.2394 23.365 24.9469 23.0725L17.8669 15.9925L17.8519 16Z"
      fill="white"
    />
  </svg>
);
